<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <v-dialog v-model="dialog.role"
          @keydown.esc="dialog.role = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Ubah Hak Akses

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.role = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Role" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Role
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Admin"

                      hide-details
                      
                      :items="role"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.role_id"
                      :success="form.role_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="roles()"
                :loading="process.role"
                :disabled="process.role"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.role = false; dialog.fullscreen = false;"
                :disabled="process.role"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selectedRow.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Produk Printer</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selectedRow.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          v-if="dialog.form"
          :fullscreen="dialog.fullscreen"
          width="700"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Tambah Produk Printer
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>

                  <v-row>

                    <v-col cols="12" class="pt-0">
                      <div class="body-2 mb-2">
                        Pilih Produk
                      </div>

                      <div>
                        <v-form>

                          <v-row>
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                rounded
                                dense
                                filled
                                hide-details
                                v-on:keydown.enter.prevent="fetchProduct()"
                                clearable


                                :color="set_color"
                                @click:clear="tocategory = ''; fetchProduct()"
                                placeholder="Pilih katagori"
                                :error-messages="errors"

                                v-on:change="fetchProduct()"

                                class="mb-2"

                                :items="category"
                                item-text="name"
                                item-value="id"

                                v-model="tocategory"
                                
                                required
                                style="border-radius: 10px;"
                                >
                              </v-autocomplete>

                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-on:keydown.enter.prevent="fetchProduct()"
                                  
                                  filled
                                  rounded
                                  dense
              
                                  :color="set_color"
                                  placeholder="Cari Data"
              
                                  hide-details
                                  clearable
                                  @click:clear="tosearch = ''; fetchProduct()"
              
                                  v-model="tosearch"
                                  class="mb-2"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>

                        <!-- {{ master_product.filter(item => !product_printer.some(element => element.product_id === item.id)) }} -->

                        <div class="view mt-1">
                          <div class="" style="height: 300px; overflow-y: auto;" v-if="!process.product">
                            <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;" class="table">
                              <tr>
                                <th style="font-size: 14px; position: sticky; top: 0; background: #fff; z-index: 1; width: 60px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">
                                  <div v-if="master_product.filter(item => !product_printer.some(element => element.product_id === item.id)).length < 1">
                                    Aksi
                                  </div>
                                  <div v-else>
                                    <v-checkbox
                                      v-model="isAllSelected"
                                      color="primary"
                                      hide-details
                                      style="margin: 0 auto;"
                                      @change="toggleSelectAll"
                                    ></v-checkbox>
                                  </div>
                                </th>
                                <th style="font-size: 14px; position: sticky; top: 0; background: #fff; z-index: 1; width: 1px;  white-space: nowrap; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Produk</th>
                                <th style="font-size: 14px; position: sticky; top: 0; background: #fff; z-index: 1; width: 100%; min-width: 100%; max-width: 100%; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Kategori</th>
                              </tr>
                              <tr v-for="(items, index) in (master_product.filter(item => !product_printer.some(element => element.product_id === item.id)))" :key="index">
                                <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 60px; min-width: 60px; max-width: 60px; text-align: center;">
                                  <v-checkbox
                                    v-model="selected"
                                    color="primary"
                                    hide-details
                                    v-on:change="toSelect(items)"
                                    :value="items.id"
                                    style="margin: 0 auto;">
                                  </v-checkbox>
                                </td>
                                <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                                  {{ items.name }}
                                </td>
                                <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; min-width: 100%; max-width: 100%; border-left: none; padding: 8px 12px; text-align: left;">
                                  {{ items.category_name }}
                                </td>
                              </tr>
                            </table>
                            <v-card-text
                              v-if="(master_product.filter(item => !product_printer.some(element => element.product_id === item.id))).length === 0"
                              class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                              <div class="text-center">
                                <div class="mt-3 fs-16">
                                  Belum ada data
                                </div>
                              </div>
                            </v-card-text>
                          </div>
                          <div class="text-center d-flex align-center justify-center" v-else style="height: 400px">
                            <div>
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                              <div>
                                Memuat Data...
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                v-if="selected.length > 0"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/user"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Pengguna
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="process.load && Object.keys(detail).length < 1"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-row>
                    <v-col cols="3">
                      <v-img
                        :src="require('@/assets/image/member_default.png')"
                        height="200px"
                        contain
                        class="border-radius">
                      </v-img>
                    </v-col>
                    <v-col cols="9">
                      <div>
                        <div>
                          Nama Perusahaan
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.company_name }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Nama Outlet
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.outlet_name }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Nama Lengkap
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.name }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Email
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.email }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Mobilephone
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.mobilephone }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Bagian
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.location_name === '' ? '-' : detail.location_name}}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Kategori
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.cat_title }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Bergabung Tanggal
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.input_datetime | datetime }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div>
                          Status 
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.is_active == 1 ? 'Aktif' : 'Tidak Aktif'}}
                        </div>
                      </div>
                    </v-col>
                    
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                class="mt-4"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12" class="py-0">
                      <div class="">
                        <div class="fs-18 font-weight-bold black_one mb-0">
                          Produk Printer
                        </div>
                        <div class="d-flex align-center pt-1">
                          <v-btn
                            @click="dialog.form = true; message.success = ''; message.error = ''; reset();"
                            :disabled="process.form"
                            color="green"
                            small
                            elevation="0"
                            class="fs-13 white--text text-capitalize d-flex align-center"
                            style="border-radius: 6px; font-weight: 600;">
                            <v-icon 
                              size="18">
                              mdi-plus-circle
                            </v-icon>
          
                            <span
                              class="ml-2">
                              Tambah
                            </span>
                          </v-btn>
                          <div v-if="product_printer.length > 0" class="ml-2">
                            <v-btn
                              @click="dialog.delete = true; selectedRow.delete = [$route.params.id];"
                              :disabled="process.delete"
                              color="red"
                              small
                              elevation="0"
                              class="fs-13 white--text text-capitalize d-flex align-center"
                              style="border-radius: 6px; font-weight: 600;">
                              <v-icon 
                                size="18">
                                mdi-delete
                              </v-icon>
            
                              <span
                                class="ml-2">
                                Hapus
                              </span>
                            </v-btn>

                          </div>
                        </div>
                      </div>

                      <div class="mt-1">
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                          <tr>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;" class="black--text">Nama Produk</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">Kategori Produk</th>
                          </tr>
                          <tr v-for="(item, index) in product_printer" :key="index">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;" class="black--text">
                              {{ item.product_name }}
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              {{ item.category_name }}
                            </td>
                          </tr>
                        </table>
                      </div>

                      <v-card-text
                        v-if="product_printer.length === 0"
                        class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                        <div class="text-center">
                          <div class="mt-3 fs-16">
                            Belum ada data
                          </div>
                        </div>
                      </v-card-text>
                      <!-- <v-divider class="my-2"></v-divider> -->
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat>
                <v-card-actions
                  class="px-4">
                  <v-spacer/>
                  
                  <v-btn
                    to="/user"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-progress-close
                    </v-icon>

                    <span
                      class="ml-2">
                      Kembali
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false,
          role: false
        },
        
        detail: {},

        role: [],

        list: [],

        form: {
          id: '',
          role_id: ''
        },
        data_array: [],
        selected: [],
        product_printer: [],
        product: [],
        master_product: [],
        selectedRow: {
          row: [],
          delete: []
        },

        tosearch: '',
        tocategory: '',
        category: [],
        
        process: {
          load: false,

          role: false,

          product: false,
          form: false,
          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      outlet () {
        return this.$store.state.outlet
      },
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      filteredProducts() {
        return this.master_product.filter(item =>
          !this.product_printer.some(element => element.product_id === item.id)
        );
      },
      isAllSelected: {
        get() {
          return (
            this.filteredProducts.length > 0 &&
            this.selected.length === this.filteredProducts.length
          );
        },
        set(value) {
          this.toggleSelectAll(value);
        },
      },
    },
    beforeMount () {
      this.fetchDetail()
    },
    mounted () {
      this.fetchCategory()
    },
    methods: {
      async fetchCategory (data) {
        let params = {
          outlet_id: this.outlet.outlet_id,
          limit: 1000000000,
          is_active: '1',
          type: 'produk'
        }
        
        await get('pos/category/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.category = res.results.data
          }
        })
      },
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`pos/user/data`, { params })
        .then(response => {
          let res = response.data


          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.fetchProductPrinter()
          }
        })
      },

      async fetchProductPrinter () {
        this.process.product = true
        let params = {
          limit: 100000000000,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/product_printer/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.product_printer = res.results.data
            this.fetchProduct()
          }
          this.process.product = false

          this.process.load = false
        })
      },

      async fetchProduct () {
        this.process.product = true
        let params = {
          limit: 100000000000,
          search: this.tosearch,
          outlet_id: this.outlet.outlet_id,
          category_id: this.tocategory,
          type: 'produk'
        }

        await get(`pos/item_sales/data_last_child`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.master_product = res.results.data
          }
          this.process.product = false
        })
      },

      reset () {
        this.data_array = []
        this.process.form = false
        this.message.error = ''
        this.selected = []
        this.tocategory = ''
        this.toSearch = ''
      },

      toSelect (item) {
        this.data_array = []
        this.selected.forEach((element, index) => {
          this.data_array.push({
            product_id: element,
            category_id: item.category_id,
            admin_id: this.$route.params.id
          })
        })
      },

      // toSelect(item) {
      //   const index = this.selected.indexOf(item.id);
      //   if (index === -1) {
      //     this.selected.push(item.id);
      //   } else {
      //     this.selected.splice(index, 1);
      //   }
      // },
      toggleSelectAll(checked) {
        if (checked) {
          this.selected = this.filteredProducts.map(item => item.id);
          this.data_array = []
          this.filteredProducts.forEach((element, index) => {
            this.data_array.push({
              product_id: element.id,
              category_id: element.category_id,
              admin_id: this.$route.params.id
            })
          })
        } else {
          this.selected = [];
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let data_array = []
          


          let url = this.form.id === '' ? 'pos/product_printer/add' : 'pos/product_printer/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              data_array: this.data_array
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchProductPrinter()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete (id) {
        this.selectedRow.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/product_printer/delete`, {
          data: {
            admin_id: this.selectedRow.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selectedRow.row = []
            this.selectedRow.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchProductPrinter()
          } else {
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>